function IconCheck() {
    return (
        <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 47.5C0.5 21.5836 21.5836 0.5 47.5 0.5C73.4164 0.5 94.5 21.5836 94.5 47.5C94.5 73.4164 73.4164 94.5 47.5 94.5C21.5836 94.5 0.5 73.4164 0.5 47.5Z" stroke="#71DE56" />
            <path d="M71.5749 37.4347L45.8455 63.1634C45.0735 63.9353 44.0603 64.3238 43.047 64.3238C42.0338 64.3238 41.0205 63.9353 40.2486 63.1634L27.3843 50.2991C25.8361 48.7516 25.8361 46.2496 27.3843 44.7022C28.9317 43.1541 31.433 43.1541 32.9811 44.7022L43.047 54.7681L65.978 31.8379C67.5254 30.2897 70.0267 30.2897 71.5749 31.8379C73.1223 33.3853 73.1223 35.8866 71.5749 37.4347Z" fill="#71DE56" />
        </svg>

    )
}
export default IconCheck;